import Adsense from './Adsense.vue';

export { Adsense };

export default {
    Adsense,
};
